import React from "react";
var __jsx = React.createElement;
import BoxLoading from "@componentsShared/placeholders/BoxLoading/BoxLoading";
import stl from "./AsideFilterLoading.module.css";
var AsideFilterLoading = function AsideFilterLoading() {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("aside", {
    className: "pe-1 mt-1 m-hide"
  }, /*#__PURE__*/React.createElement(BoxLoading, {
    className: "mb-1",
    divWidth: 120,
    divHeight: 30
  }), /*#__PURE__*/React.createElement(BoxLoading, {
    className: "mb-2",
    divWidth: 252,
    divHeight: 90
  }), /*#__PURE__*/React.createElement(BoxLoading, {
    className: "mb-1",
    divWidth: 252,
    divHeight: 130
  }), /*#__PURE__*/React.createElement(BoxLoading, {
    className: "mb-2",
    numberOfLoaders: 20,
    divWidth: 252,
    divHeight: 50
  })), /*#__PURE__*/React.createElement("div", {
    className: ["m-show", stl.mobileLoading].join(" ")
  }, /*#__PURE__*/React.createElement(BoxLoading, {
    className: stl.mobileHeaingShimmer,
    divHeight: 28
  }), /*#__PURE__*/React.createElement(BoxLoading, {
    className: stl.mobileSearchShimmer,
    divHeight: 48
  }), /*#__PURE__*/React.createElement(BoxLoading, {
    className: stl.mobilefiltersShimmer,
    divHeight: 47
  }), /*#__PURE__*/React.createElement("div", {
    className: stl.mobileTagsShimmer
  }, /*#__PURE__*/React.createElement(BoxLoading, {
    divHeight: 26
  }), /*#__PURE__*/React.createElement(BoxLoading, {
    divHeight: 26
  })), /*#__PURE__*/React.createElement(BoxLoading, {
    className: stl.mobileBannerShimmer,
    divHeight: 120
  }), /*#__PURE__*/React.createElement(BoxLoading, {
    className: stl.mobileTextShimmer,
    divHeight: 48
  })));
};
export default AsideFilterLoading;